import Joi from 'joi'
import errorsResolver from '../../../../validation/schemeUtils'
import {config} from "../../../../helpers/config";

const additionalInfoLength = 300
const warningCheckingForInvalidCharacters = `Поле ввода содержит некорректные символы`
const ADD_INFO_FIELD_LENGTH = 38
const IMEI_LENGTH = config().validatePurities ? 15 : 100;
const SN_LENGTH = config().validatePurities ? 25 : 100;
const NAME_LENGTH = config().validatePurities ? 40 : 200;
const MODEL_LENGTH = config().validatePurities ? 32 : 150;
const isRequiredEstimatedValue = config().validateThings;

const thingsSchema = Joi.object({
    name: Joi.string()
        .required()
        .max(NAME_LENGTH)
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+,!{}#()$%^&*~_/,№:?”`\\[\\]\\- ]*$'))
        .error(errorsResolver({
            required: 'Наименование вещи обязательное поле',
            max: `Поле не должно иметь больше ${NAME_LENGTH} символов`,
            pattern: warningCheckingForInvalidCharacters,
        })),
    model: Joi.string()
        .max(MODEL_LENGTH)
        .allow('')
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,!{}#()$%^&*~_/,№:?”`\\- ]*$'))
        .error(errorsResolver({
            max: `Поле не должно иметь больше ${MODEL_LENGTH} символов`,
            pattern: warningCheckingForInvalidCharacters,
        })),
    quantity: Joi.number()
        .required()
        .min(1)
        .empty('')
        .error(errorsResolver({
            required: 'Количество обязательное поле',
            numberMin: 'Количество должно быть больше 0',
            numberUnsafe: 'Некорректное число'
        })),
    imei: Joi.string()
        .max(IMEI_LENGTH)
        .allow('')
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,!{}#()$%^&*~_/,№:?”`\\- ]*$'))
        .error(errorsResolver({
            max: `Поле не должно иметь больше ${IMEI_LENGTH} символов`,
            pattern: warningCheckingForInvalidCharacters,
        })),
    sn: Joi.string()
        .max(SN_LENGTH)
        .allow('')
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,!{}#()$%^&*~_/,№:?”`\\- ]*$'))
        .error(errorsResolver({
            max: `Поле не должно иметь больше ${SN_LENGTH} символов`,
            pattern: warningCheckingForInvalidCharacters,
        })),
    estimatedValue: isRequiredEstimatedValue ?
        Joi.string()
            .required()
            .error(errorsResolver({
                required: 'Оценочная стоимость обязательное поле',
            })) :
        Joi.number()
            .min(0)
            .empty('')
            .error(errorsResolver({
                numberBase: 'Оценочная стоимость должна быть числом',
                numberMin: 'Оценочная стоимость должна быть больше 0',
                numberUnsafe: 'Некорректное число'
            })),
    comment: Joi.string()
        .allow('')
        .max(250)
        .error(errorsResolver({
            max: 'Длина комментария должна быть меньше или равна 250 символам'
        })),
    additionalInfo: Joi.string()
        .allow('')
        .max(ADD_INFO_FIELD_LENGTH)
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,-!()_/,№:?”;" ]*$'))
        .min(0)
        .error(errorsResolver({
            max: `Длина комментария должна быть меньше или равна ${ADD_INFO_FIELD_LENGTH} символам`,
            pattern: warningCheckingForInvalidCharacters,
        })),
})

const thingsFormSchema = Joi.object({
    things: thingsSchema,
    additionalInformation: Joi.string()
        .allow('')
        .max(additionalInfoLength)
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.\\-,/+!{}#()$%^&*~_№:?"\\\\ \\n]*$'))
        .error(errorsResolver({
            max: `Длина комментария должна быть меньше или равна ${additionalInfoLength} символам`,
            pattern: warningCheckingForInvalidCharacters,
        })),
})

export default thingsFormSchema
